import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import AddStockOrderActionModalContainer from './AddStockOrderActionModalContainer';
import {setStockorderAddStockOrderModal} from '../../../../store/slice/ManufSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '95%', xs: '95%' },
  height: { lg: '95%', xs: '95%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function AddStockOrderActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {AddStockOrderModalOpen, stockorderObj} = useSelector((state)=>state.manufslice.stockorderDashboard);

  useEffect(()=>{
  },[AddStockOrderModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setStockorderAddStockOrderModal(false));
  }
  return (
    <Modal
       open={AddStockOrderModalOpen===undefined?false:AddStockOrderModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center"
        sx={{borderBottom:'1px solid #e0e0e0'}}>
          <Grid item>
            <Typography variant="h5"  >
              Add Stock Order @ {stockorderObj.title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item paddingTop={1}> 
            < AddStockOrderActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}